
import { defineComponent, ref, watch } from "vue";
import { Field, ErrorMessage } from "vee-validate";

export default defineComponent({
  name: "funding-round-stage-update",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    fundingRound: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const formData = ref<Record<string, unknown>>(props.fundingRound);
    const fundingRoundName = ref<string>("");
    const syncData = (value) => {
      fundingRoundName.value = value.fundingRoundName;
    };
    watch(() => props.fundingRound, (value) => {
      formData.value = value
      syncData(value)
    });
    const fieldChanged = (event) => {
      formData.value[event.target.name] = event.target.value;
      emit("form-data", formData.value);
    };
    return {
      formData,
      fieldChanged,
      fundingRoundName,
    };
  },
});
